var humbleshop = {
  el : {
    flexcarousel : $('#flexcarousel'),
    flexslide : $('#flexslider'),
    flexcarouselthumb : $('#flexcarousel-product'),
    flexsliderthumb : $('#flexslider-product'),
    flexbrand : $('#flexcarousel-brands'),
    mainnav : $('.horizontal-nav ul li'),
    nav : $('.horizontal-nav ul li').not('.horizontal-nav ul li li'), 
    size : $('.horizontal-nav ul li').not('.horizontal-nav ul li li').size(),
    bubble : $('.counter a'),
    closeme : $('#closeit'),
    tab : $('#myTab a, #myTab button'),
    fancypop : $('a[data-fancybox-group="zoom"]'),
    toggle : $('.product h6.subhead'),
  },
  theslider : function(){
    
    this.el.flexcarousel.flexslider({
      animation: "slide",
      controlNav: false,
      animationLoop: false,
      slideshow: false,
      itemWidth: 192,
      //itemMargin: 5 ,
      asNavFor: '#flexslider'
    });

    this.el.flexslide.flexslider({
      animation: "slide",
      controlNav: true,
      animationLoop: false,
      slideshow: true,
      slideshowSpeed: 5000,
      animationSpeed: 600,
      smoothHeight : true,
      sync: "#flexcarousel"
    });

    this.el.flexcarouselthumb.flexslider({
      animation: "slide",
      controlNav: false,
      animationLoop: false,
      slideshow: false,
      itemWidth: 115,
      asNavFor: "#flexslider-product"
    });
    
    this.el.flexsliderthumb.flexslider({
      animation: "slide",
      controlNav: true,
      animationLoop: false,
      slideshow: false,
      sync: "#flexcarousel-product"
    });

    this.el.flexbrand.flexslider({
      animation: "slide",
      controlNav: false,
      animationLoop: true,
      slideshow: false,
      itemWidth: 180,
    });

  },
  thenav : function(){
    percent = 100/this.el.size;
    this.el.nav.css('width', percent+'%').parent().show();

    this.el.mainnav.mouseenter(function(){
      $('ul', this).stop().slideDown('fast');
    }).mouseleave(function(){
      $('ul', this).stop().slideUp(150);
    });

    selectnav('nav', { label: 'Menu' });
  },
  
  theios : function(){
    var iOS = false,
    p = navigator.platform;
    
    if( p === 'iPad' || p === 'iPhone' || p === 'iPod' ){
      iOS = true;
      
    $(function(){
        $('.view-thumb').bind('hover', function(e){
          e.preventDefault();
          $(this).toggleClass('hovere');
        });
      });    
    }
  },
  theothers : function(){
    this.el.bubble.on('click', function(){
      $('.cartbubble').slideToggle();
    });
    this.el.closeme.on('click',function(e){
      e.preventDefault;
      $('.cartbubble').slideUp();
    });
    this.el.tab.click(function (e) {
      e.preventDefault();
      $(this).tab('show');
    });
    this.el.fancypop.fancybox();
    this.el.toggle.on('click', function(){
      $('.query').slideToggle();
    });
	$('.collapse').collapse()
    $('article').fitVids();
  },
  init : function(){
    this.theslider();
    this.thenav();    
    this.theothers();
    this.theios();
  }

}

$(window).load(function(){ 
  humbleshop.init();
});